import {
  Box, Typography,
} from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { FC } from 'react';

import { InventoryCustomAction } from 'constants/enums';

import { StyledInventoryActionDataGrid } from './index.styled';

interface SelectedItemsTableProps {
  rows: GridRowsProp;
  columns: GridColDef[];
  customAction: InventoryCustomAction;
}

const SelectedItemsTable: FC<SelectedItemsTableProps> = ({ rows, columns, customAction }) => (
  <>
    <Box display="flex" justifyContent="center" mb={2}>
      <Typography variant="h6" fontWeight={500}>Selected Items</Typography>
    </Box>
    <Box>
      <StyledInventoryActionDataGrid
        customAction={customAction}
        rows={[...rows]}
        columns={columns}
        disableColumnFilter
        disableColumnMenu
        disableColumnSorting
        disableRowSelectionOnClick
        hideFooter
      />
    </Box>
  </>
);
export default SelectedItemsTable;
